import React, { useEffect, useState } from "react";
import styles from "./Toast.module.css";

interface ToastProps {
  message: string;
  type: "success" | "error";
  onClose: () => void;
  duration?: number;
}

const Toast: React.FC<ToastProps> = ({
  message,
  type,
  onClose,
  duration = 3000,
}) => {
  const [exiting, setExiting] = useState(false);

  useEffect(() => {
    const fadeTimer = setTimeout(() => setExiting(true), duration - 300);
    const closeTimer = setTimeout(onClose, duration);
    return () => {
      clearTimeout(fadeTimer);
      clearTimeout(closeTimer);
    };
  }, [duration, onClose]);

  return (
    <div
      className={`${styles.toast} ${
        type === "success" ? styles["toast--success"] : styles["toast--error"]
      } ${exiting ? styles["toast--exit"] : ""}`}
      role="alert"
    >
      <span className={styles.toast__icon}>
        {type === "success" ? "✓" : "✕"}
      </span>
      <span className={styles.toast__message}>{message}</span>
      <button
        type="button"
        className={styles.toast__close}
        onClick={onClose}
        aria-label="Close"
      >
        ×
      </button>
    </div>
  );
};

export default Toast;
